import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ko',
    fullName: 'Korean',
    nativeName: '한국어',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "놀라운 일이 다가오고 있습니다",
    landing_subtitle: "ArgVoid는 앱 및 게임 개발 스튜디오입니다. 계속 지켜봐 주시기 바랍니다. 새로운 기능이 곧 출시될 예정입니다!",
    select_language: "언어 선택",
    search_placeholder: "언어 검색...",
    terms_title: "서비스 약관",
    policy_title: "개인 정보 보호 정책",
    cookies_title: "쿠키 정책",
    terms_content: `
        <strong>1. 약관 동의</strong><br>
        ArgVoid에 액세스하면 본 서비스 약관에 동의하게 됩니다. 본 약관에 동의하지 않는 경우 서비스를 이용할 수 없습니다.<br><br>

        <strong>2. 플랫폼 사용량</strong><br>
        ArgVoid 및 해당 애플리케이션은 정보 제공 및 창의적 목적으로 "있는 그대로" 제공됩니다. 서비스는 합법적인 목적으로만 이용되어야 합니다.<br><br>

        <strong>3. 금지된 행위</strong><br>
        사이트 취약점 악용, 스팸 발송 또는 인프라에 대한 무단 액세스 시도는 엄격히 금지됩니다.<br><br>

        <strong>4. 면책 조항</strong><br>
        플랫폼과 서비스는 사전 통지 없이 언제든지 수정될 수 있습니다. 서비스 가동 시간이나 가용성에 대해서는 어떠한 보증도 제공되지 않습니다.
    `,
    policy_content: `
        <strong>1. 정보수집</strong><br>
        현재 플랫폼에는 사용자 인증이나 계정 생성이 필요하지 않습니다. 방문자로부터 개인 식별 정보(예: 이름, 이메일 주소)는 적극적으로 수집되지 않습니다.<br><br>

        <strong>2. 사용 데이터</strong><br>
        사이트 트래픽을 이해하고 애플리케이션을 개선하기 위해 기본적이고 익명화된 분석이 수집될 수 있습니다. 이 데이터는 개별 사용자 ID와 연결되어 있지 않습니다.<br><br>

        <strong>3. 타사 서비스</strong><br>
        호스팅 및 분석 서비스를 위해 제3자 제공업체를 활용할 수 있습니다. 해당 제공업체의 개인정보 보호 관행은 해당 인프라에서 처리되는 익명 데이터에 적용됩니다.<br><br>

        <strong>4. 데이터 보안</strong><br>
        플랫폼을 보호하기 위해 합리적인 보안 조치가 구현됩니다. 그러나 인터넷을 통한 전송 방법은 완전히 안전하지 않습니다.<br><br>
    `,
    cookies_content: `
        <strong>1. 쿠키와 로컬 저장소란 무엇입니까?</strong><br>
        쿠키와 브라우저 로컬 저장소는 방문 시 구성 기본 설정을 기억하기 위해 장치에 저장되는 작은 데이터 파일입니다.<br><br>

        <strong>2. 사용목적</strong><br>
        브라우저 LocalStorage는 <br>와 같은 구성 설정을 저장하는 데 엄격하게 사용됩니다.
        - 언어 기본 설정<br>
        - 사용자 인터페이스 구성(예: 레이아웃 또는 테마 설정)<br>
        - 임시 애플리케이션 캐시<br><br>

        <strong>3. 추적 없음</strong><br>
        쿠키 및 로컬 저장소는 광고 또는 제3자 추적 목적으로 사용되지 않습니다. 저장된 모든 데이터는 플랫폼의 핵심 기능을 위한 것입니다.<br><br>

        <strong>4. 컨트롤</strong><br>
        브라우저 데이터는 브라우저 설정을 통해 언제든지 삭제될 수 있으며, 이로 인해 모든 로컬 구성이 재설정됩니다.
    `,
    cookie_consent_text: "당사는 세션 활성 유지, 언어 기본 설정 저장, 기타 사용자 정의 구성 등 웹사이트가 올바르게 작동하는지 확인하기 위해 기본 쿠키를 사용합니다.",
    read_policy: "쿠키 정책 읽기",
    support_title: "지원팀에 문의",
    support_subject_label: "주제",
    support_message_label: "메시지",
    support_submit_button: "메시지 보내기",
    support_hint: "참고: 이렇게 하면 메시지를 보낼 수 있는 기본 이메일 애플리케이션이 열립니다.",
    support_success_msg: "이메일 앱을 여는 중...",
    support_error_msg: "메시지를 보내지 못했습니다. 나중에 다시 시도해 주세요.",
    explorer_title: "탐침",
    history_title: "역사",
    animation_title: "생기",
    config_title: "구성",
    tool_mouse: "선택(Ctrl+M)",
    tool_brush: "브러시(Ctrl+B)",
    tool_brush_mode: "토글 모드(솔리드/클리어)",
    tool_eraser: "지우개(Ctrl+E)",
    tool_brush_size: "브러시 크기 조정",
    tool_bucket: "채우기(Ctrl+F)",
    tool_eyedropper: "스포이드",
    tool_grid: "그리드(Ctrl+Shift+B)",
    tool_rotate: "회전(Ctrl+Shift+R)",
    tool_flip_h: "H 뒤집기(Ctrl+Shift+H)",
    tool_flip_v: "V 뒤집기(Ctrl+Shift+V)",
    tool_transpose: "조옮김(Ctrl+Shift+T)",
    label_width: "너비",
    label_height: "키",
    label_frames: "프레임 수",
    label_animation: "애니메이션 스타일",
    label_background_color: "배경색",
    label_interval: "간격",
    tool_anim_config: "애니메이션 구성",
    label_new_width: "새로운 너비",
    label_new_height: "새로운 높이",
    label_apply: "적용하다",
    label_colors: "그림 물감",
    label_size: "크기",
    label_tolerance: "용인",
    val_horizontal: "수평의",
    val_vertical: "수직의",
    val_sequence: "순서",
    val_bounce: "되튐",
    val_random: "무작위의",
    val_solid: "단단한",
    val_clear: "분명한",
    action_add_sheet: "새 시트",
    action_import: "수입",
    action_export: "내보내다",
    action_sort_projects: "종류",
    sort_date_old: "오래된 것부터",
    sort_date_new: "최신순",
    sort_name_az: "이름(A~Z)",
    sort_name_za: "이름(Z-A)",
    action_new_sprite: "새로운 스프라이트",
    action_new_project: "새 프로젝트",
    modal_save_all_title: "모든 변경 사항 저장",
    modal_save_all_desc: "저장할 자산을 선택하세요:",
    modal_save_selected: "선택 항목 저장",
    action_saved: "저장됨",
    modal_create_sprite_title: "새 스프라이트 만들기",
    modal_create_project_title: "새 프로젝트 만들기",
    modal_add_sheet_title: "새 시트 추가",
    modal_rename_sheet_title: "시트 이름 바꾸기",
    modal_rename_sprite_title: "스프라이트 이름 바꾸기",
    modal_delete_sprite_title: "스프라이트 삭제",
    modal_delete_project_title: "프로젝트 삭제",
    modal_delete_sheet_title: "시트 삭제",
    placeholder_sprite_name: "이름",
    placeholder_project_name: "이름",
    placeholder_sheet_name: "이름",
    placeholder_new_name: "새 이름",
    action_create: "만들다",
    action_add: "추가하다",
    action_rename: "이름 바꾸기",
    action_duplicate: "복제하다",
    action_delete: "삭제",
    action_cancel: "취소",
    confirm_delete_sprite: "정말로 이 스프라이트를 삭제하시겠습니까?",
    confirm_delete_project: "이 프로젝트를 삭제하시겠습니까? 모든 스프라이트가 제거됩니다.",
    confirm_delete_sheet: "이 시트를 삭제하시겠습니까?",
    err_select_sprite: "먼저 스프라이트를 선택하세요.",
    err_select_project: "먼저 프로젝트를 선택해주세요.",
    err_name_empty: "이름은 비워둘 수 없습니다.",
    err_sprite_exists: "해당 이름을 가진 스프라이트가 이미 존재합니다.",
    err_project_exists: "해당 이름의 프로젝트가 이미 존재합니다.",
    err_no_content: "저장할 콘텐츠가 없습니다.",
    err_no_changes: "저장할 변경사항이 없습니다.",
    err_delete_last_sheet: "마지막 시트를 삭제할 수 없습니다.",
    err_extract_frames: "프레임을 추출할 수 없습니다.",
    err_indexeddb: "로컬에 저장하지 못했습니다. 귀하의 브라우저가 IndexedDB를 지원하지 않을 수 있습니다.",
    msg_upload_success: "업로드 성공: {0}",
    msg_upload_failed: "업로드 실패: {0}",
    msg_save_success: "저장에 성공했습니다.",
    msg_saving: "절약...",
    msg_multi_save_result: "{0}개의 자산을 저장했습니다. {1} 실패.",
    menu_title: "메뉴",
    menu_save: "구하다",
    menu_save_all: "모두 저장",
    menu_support: "지원팀에 문의",
    label_local_storage: "로컬 저장소",
    label_sign_in: "로그인",
    modal_export_title: "스프라이트 내보내기",
    label_filename: "파일 이름",
    label_format: "체재",
    action_export_confirm: "내보내다",
};

export default translations;
